export default {"src":"/_next/static/media/nxs.d85d9d1b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};